"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Qrcode = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Qrcode"));

// Generated by script, don't edit it please.
var Qrcode = (0, _createSvgIcon["default"])({
  as: _Qrcode["default"],
  ariaLabel: 'qrcode',
  category: 'application',
  displayName: 'Qrcode'
});
var _default = Qrcode;
exports["default"] = _default;
module.exports = exports.default;